export const dataHooks = {
  title: 'sidebarheader-title',
  subtitle: 'sidebarheader-subtitle',
  children: 'sidebarheader-children',
};
